import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "../../components/general.css"
import * as blogArticleStyle from "../../components/blog-article.module.css"
import Layout from "../../components/layout"
import articleImage from "../../images/blog_10.png"

const Article10 = () => {

  const [articleTitle, setArticleTitle] = React.useState("");

  React.useEffect(() => {
    const articleTitle = window.location.pathname.split('/')[2].replaceAll('-', ' ');
    setArticleTitle(articleTitle);
    console.log(articleTitle)
  }, [])

  return (
    <main>
      <Layout>
        <section className={blogArticleStyle.articleSection}>

          <div
            style={{
              background: `url(${articleImage})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className={blogArticleStyle.headerImage}
          >
            <div>
              <span>21 AOÛT 2019 - JEUX VIDÉO, SMARTPHONES - 4 MIN</span>
            </div>
            <div>
              <h1 className={blogArticleStyle.mainTitle}>{articleTitle}</h1>
            </div>
            <div className={blogArticleStyle.authorId}>
              <StaticImage src="../../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's"></StaticImage>
              <span>Par Mobile Lab's</span>
            </div>
          </div>

          <div className={blogArticleStyle.mainContent}>
            <p>Depuis Snake 3310, les jeux vidéo font partie intégrante de l’histoire du téléphone mobile. C’est aujourd’hui l’une des causes principales de l’augmentation de la puissance de nos téléphones.</p>

            <h2>Les jeux vidéo sur Smartphones</h2>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/cellular-telephone-communication-connection-278998-1-768x512.png" alt="" />
            </div>

            <p>Avec l’arrivée de gros titres tels que Mario, PUBG ou encore Final Fantasy, les constructeurs mettent
              tout en œuvre pour fournir les meilleures performances à leurs utilisateurs. Grâce à cela, nous sommes
              capables aujourd’hui d’apporter le jeu vidéo partout avec nous. Pendant la pause repas ou encore dans
              les transports en commun, nous pouvons jouer à n’importe quel moment de la journée. Du jeu tir avec
              Fortnite, de la stratégie comme Clash of Clan ou du Puzzle game avec le fameux Candy Crush, il y en a
              pour tous les goûts !&nbsp;</p>
            <p>Le monde du gaming mobile s’affiche comme un sérieux concurrent à l’univers PC/Console surtout avec son
              entrée dans le monde de l’esport où certains tournois proposent des cashprize pouvant s’élever à 100
              000$. Mais c’est loin de remplacer nos bonnes vieilles consoles. En effet, les sensations ne sont pas
              les mêmes : commandes tactile, petit écran. Le jeu Smartphone a un grand avenir devant lui, il ne lui
              reste plus qu’à être accepté par la communauté des joueurs comme une réelle plateforme de jeu. Et pour
              cela certains constructeurs ont préparé des Smartphones spécialement conçus pour l’occasion.<br /></p>
            <h3><strong>Les Smartphones gaming</strong>&nbsp;<br /></h3>
            <h4><strong>Asus</strong> <strong>ROG Phone 2</strong></h4>
            <p>Profitant d’une amélioration de la puce graphique de son Snapdragon 855 Plus, le Asus ROG 2 débarque
              dans une nouvelle version sur-booster. Avec un Écran AMOLED 120hz et son design futuriste, il a tout
              pour séduire.</p>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/asus-rogue-1.png" alt="" />
            </div>

            <h4><strong>Xiaomi Black Shark 2 Pro</strong></h4>
            <p>Nouvelle écran complètement repensé, le nouveau téléphone spécial jeux vidéo de chez Xiaomi propose la
              latence tactile la plus faible de tous les smartphones. En plus de ses performances gaming, le nouveau
              Black Shark propose un très bon double capteur photo de chez Sony. Lui aussi a le droit au dernier
              Snapdragon 855 Plus. Niveau design, comme la concurrence, un style purement gaming très appréciable.</p>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/Xiaomi-Black-Shark-2-Pro-Ice-Ash.png" alt="" />
            </div>

            <h4><strong>Razer Phone 2</strong></h4>
            <p>Grand constructeur de périphérique gaming pour PC, Razer nous propose un Smartphone haute performance
              dédié aux jeux mais avec un design beaucoup plus sobre. Niveau écran, nous avons le droit à un LCD très
              bien calibré niveau couleurs. Cependant petit bémol pour la batterie, à voir si Razer fera mieux sur les
              prochains modèles.</p>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/2018-10-11-product-9-600x688.png" alt="" />
            </div>

            <h3><strong>Le Gaming Cloud</strong></h3>
            <p>Malgré des performances exceptionnelles pour de si petites machines, le Smartphone reste loin derrière
              par rapport à des PC gamer ou des consoles de salon. Toutefois, il est possible d’utiliser un PC à
              distance permettant ainsi de profiter des performances d’un ordinateur sur son mobile, et cela même en
              déplacement grâce au réseau mobile.</p>
            <p><a href="https://shadow.tech/">Shadow</a>, par exemple, vous propose un PC en Cloud (hébergement à
              distance) doté de performances gaming, tout cela disponible sur iOs et Android (tablette ou smartphone).
              D’autres, comme Steam Link, utilisent la puissance de votre ordinateur et le projette directement, grâce
              au streaming, sur votre téléphone et tout cela gratuitement (uniquement disponible sur les jeux de la
              plateforme Steam).</p>
            <p>Le seul défaut du gaming cloud reste la qualité des connexions, mais tout cela semble en bonne voie,
              surtout au vu des performances de la fibre et de la
              <a href="mobile-labs.fr/blog/deploiement-de-la-5g-en-france/">5G</a> qui sont en cours de déploiement
              sur le territoire français.</p>
            <p>J’espère que cela vous aura plus. Si vous avez des questions sur le sujet de l’article, n’hésitez pas à
              les poser directement dans l’espace commentaire 😉
            </p>
          </div>
        </section>
      </Layout>
    </main >
  )
}

export default Article10

export const Head = () => (
  <>
    <html lang="fr" />
    <title>Mobile Lab's BLOG  | La puissance des jeux vidéo smartphones</title>
    <meta name="description" content="Depuis Snake 3310, les jeux vidéo font partie intégrante de l’histoire du téléphone mobile. C’est aujourd’hui l’une des causes principales de l’augmentation de la puissance de nos téléphones. Les jeux vidéo sur Smartphones Avec l’arrivée de gros titres tels que Mario, PUBG ou encore Final Fantasy, les constructeurs mettent tout en œuvre pour fournir les […]" />

    <link rel="icon" type="image/png" href="../images/logos/mobilelabs_favicon.png"></link>
  </>
)
